/** Import libs */
/** -------------------------------------- */

// Alpine.js
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

// Clipboard.js
import ClipboardJS from 'clipboard/dist/clipboard.min.js';

// Tippy.js
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

// Lottie
import LottiePlayer from '@lottiefiles/lottie-player';

// Import Headroom.js
import Headroom from "headroom.js";

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

// Chocolat Lightbox
// Used in news-gallery for lightbox support.
import Chocolat from 'chocolat';
import "chocolat/dist/css/chocolat.css";

// Import Flowbite.js
import 'flowbite';

// Import Swiper.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/** Functions */
/** -------------------------------------- */
 
// Alpine.js
Alpine.plugin(intersect)
window.Alpine = Alpine
 
Alpine.start()

// Clipboard.js
// Check if .js-clipboard-link exists
if (document.querySelector('.js-clipboard-link')) {
	new ClipboardJS('.js-clipboard-link');
	// If it does, then initialize ClipboardJS
	tippy('.js-clipboard-link', {
		content: (reference) => reference.getAttribute('data-tippy'),
		trigger: 'click',
		placement: 'bottom',
	});
}

// AOS (Animate on Scroll) initialisation

// Check if .aos exists or data-aos exists
if ( document.querySelector('.aos') || document.querySelector('[data-aos]') ) {
	AOS.init();
}

// Chocolat Lightbox
// Check if .chocolat-image exists
if (document.querySelector('.chocolat-image')) {
	// If it does, then initialize Chocolat
	Chocolat(document.querySelectorAll('.chocolat-image'), {
		// options here
		loop: true,
	})
}

// Navigation helper functions
jQuery('header').addClass('bg-transparent');

// Return to bg-transparent if scrolled to top
jQuery(window).on('scroll', function() {
	// has scrolled past the top
	if ( jQuery(window).scrollTop() > 0 ) {
		var hasScrolled = true;
		if ( jQuery('.desktop-nav--white').length && hasScrolled == true ) {
			jQuery('header').addClass('bg-black').removeClass('bg-transparent');
			var hasScrolled = false;
		} else {
			var hasScrolled = true;
			if ( hasScrolled == true ) {
				jQuery('header').addClass('bg-white').removeClass('bg-transparent');
				var hasScrolled = false;
			}
		}
	}
	if ( jQuery(window).scrollTop() == 0 ) {
		jQuery('header').addClass('bg-transparent').removeClass('bg-black bg-white');
		var hasScrolled = false;
	}	
});


// Headroom.js
// Grab the desktop and mobile navbars
if ( jQuery('header.desktop-nav').length || jQuery('header.mobile-nav').length ) {
	var navDesktop = jQuery('header.desktop-nav')[0];
	var navMobile = jQuery('header.mobile-nav')[0];
	// Set options for Headroom.js
	var options = {
		// vertical offset in px before element is first unpinned
		offset: 300,
	};
	// construct the headroom instances and set the options
	var headroomDesktop  = new Headroom(navDesktop, options);
	var headroomMobile  = new Headroom(navMobile, options);
	// initialise
	headroomDesktop.init();
	headroomMobile.init();
}


/**
 * Line animation
 */
if (document.getElementById('line-animation')) {
    const container = document.getElementById('line-container');
    const wrapper = document.getElementById('line-wrapper');
    const line = document.getElementById('line-svg');
    const heading = document.querySelector('.line-heading');
    
    // Samla alla kort och deras centerpositioner
    const cards = [];
    for (let i = 1; i <= 4; i++) {
        const card = document.getElementById(`line-card-${i}`);
        if (card) {
            const cardImage = card.querySelector('img');
            cards.push({
                element: card,
                top: card.offsetTop,
                height: card.offsetHeight,
                imageHeight: cardImage ? cardImage.offsetHeight : 0
            });
        }
    }

    // Beräkna total höjd (heading + alla kort - halva sista bildens höjd)
    const lastCard = cards[cards.length - 1];
    const totalHeight = (lastCard.top + lastCard.height - (lastCard.imageHeight / 2)) - heading.offsetTop;

    // Sätt initial höjd på SVG container
    wrapper.style.height = totalHeight + 'px';
    line.style.height = totalHeight + 'px';

    let isScrolling = false;
    let currentHeight = 0;
    let animationFrame;

    function lerp(start, end, factor = 0.1) {
        return start + (end - start) * factor;
    }

    function updateHeight() {
        const scrollY = window.scrollY;
        const startPoint = heading.offsetTop;
        const progress = Math.max(0, Math.min(1, (scrollY - startPoint) / (totalHeight)));
        
        // Beräkna target height
        const targetHeight = progress * totalHeight;
        
        // Använd lerp för mjukare animation
        currentHeight = lerp(currentHeight, targetHeight, 0.1);
        
        // Uppdatera max-height för att visa/dölja linjen
        wrapper.style.maxHeight = currentHeight + 'px';
        
        // Fortsätt animera om vi inte har nått target
        if (Math.abs(currentHeight - targetHeight) > 0.1) {
            animationFrame = requestAnimationFrame(updateHeight);
        } else {
            isScrolling = false;
        }
    }

    function handleScroll() {
        if (!isScrolling) {
            isScrolling = true;
            cancelAnimationFrame(animationFrame);
            animationFrame = requestAnimationFrame(updateHeight);
        }
    }

    // Kör updateHeight en gång vid start för att sätta initial position
    updateHeight();
    window.addEventListener('scroll', handleScroll);
}

/**
 * Line animation stack
 */
if (document.getElementById('line-stack-animation')) {
    // Get the container element with the ID 'line-stack-container'
    const stackContainer = document.getElementById('line-stack-container');
    
    // Get the wrapper element with the ID 'line-stack-wrapper'
    const stackWrapper = document.getElementById('line-stack-wrapper');
    
    // Get the line element with the ID 'line-stack-svg'
    const stackLine = document.getElementById('line-stack-svg');
    
    // Set the height of the line element to match the height of the container
    stackLine.style.height = '1950' + 'px';

    // Get the card1 element with the ID 'line-stack-card-1'
    const stackCard1 = document.getElementById('line-stack-card-1');
    
    // Calculate the vertical center position of card1
    const stackCard1_center = stackCard1.offsetTop + (stackCard1.offsetHeight / 2);

    // Get the card2 element with the ID 'line-stack-card-2'
    const stackCard2 = document.getElementById('line-stack-card-2');
    
    // Calculate the vertical center position of card2
    const stackCard2_center = stackCard2.offsetTop + (stackCard2.offsetHeight / 2);

    // Initialize a flag to track scrolling state
    let isScrolling = false;

    // Create a debounce function to limit the frequency of scroll event handling
    function debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            const later = () => {
                timeout = null;
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Function to update the height of the wrapper based on scroll position
    function updateHeight() {
        if (window.scrollY < stackCard1_center) {
            stackWrapper.style.maxHeight = '0rem';
        } else if (window.scrollY > stackCard1_center && window.scrollY < stackCard2_center) {
            stackWrapper.style.maxHeight = stackCard1_center + 'px';
            console.log('stack-card1');
        } else if (window.scrollY > stackCard2_center) {
            console.log('stack-card2');
            stackWrapper.style.maxHeight = stackCard2_center + 'px';
        }
        isScrolling = false;
    }

    // Function to handle scroll events and trigger the updateHeight function
    function handleScroll() {
        if (!isScrolling) {
            isScrolling = true;
            requestAnimationFrame(updateHeight);
        }
    }

    // Add a scroll event listener with debounce to improve performance
    window.addEventListener('scroll', debounce(handleScroll));
}

// Content is loaded
document.addEventListener("DOMContentLoaded", function () {

	// Block: Slider content 
    new Swiper(".js-content-slider", {
        freeMode: true,
        sticky: true,
        grabCursor: true,
        spaceBetween: 48,
        slidesPerView: 1.2,
        breakpoints: {
            768: {
                slidesPerView: 1.8,
            },
            1024: {
                slidesPerView: 2.4,
            },
        },
        navigation: {
            nextEl: ".js-content-slider-next",
        },
    });

    // Video placeholder functionality
    // Kontrollera om det finns några video-placeholders på sidan för att undvika att köra onödig kod
    const placeholders = document.querySelectorAll(".video-placeholder");
    if (placeholders.length > 0) {
        placeholders.forEach(function (placeholder) {
            placeholder.addEventListener("click", function () {
                let embedCode = placeholder.getAttribute("data-embed");

                // Lägg till autoplay om det är en YouTube eller Vimeo-länk
                if (embedCode.includes("youtube.com") || embedCode.includes("vimeo.com")) {
                    embedCode = embedCode.replace("?", "?autoplay=1&");
                }

                // Skapa en wrapper för att behålla aspect ratio
                const videoWrapper = document.createElement("div");
                videoWrapper.classList.add("relative", "w-full", "h-0", "pb-[56.25%]", "overflow-hidden");
                
                // Modifiera iframe-attributen för bättre responsivitet
                embedCode = embedCode.replace('<iframe', '<iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"');
                videoWrapper.innerHTML = embedCode;

                // Ersätt placeholder med videon
                placeholder.replaceWith(videoWrapper);
            });
        });
    }
});

// jQuery functions
jQuery(document).ready(function () {

    // Function to load content based on category
    function loadContentByCategory(category) {
        jQuery.ajax({
            type: 'GET',
            url: '/wp/wp-admin/admin-ajax.php',
            data: { 
                action: 'yabie_filter_partners_ajax', // Ajax action name
                category: category 
            },
            success: function (response) {
                jQuery('#partner-grid').html(response);
            },
            error: function (error) {
                console.error('Error:', error);
            }
        });
    }

    // Check URL on page load and load the content
    var urlParams = new URLSearchParams(window.location.search);
    var initialCategory = urlParams.get('category');
    if (initialCategory) {
        jQuery('#category-filter').val(initialCategory); // Set the dropdown value
        loadContentByCategory(initialCategory); // Load the content based on the category
    }

    // Filter partners by category on dropdown change
    jQuery('#category-filter').on('change', function () {
        var selectedCategory = jQuery(this).val();

        // Update the URL
        var newUrl = new URL(window.location.href);
        if (selectedCategory) {
            newUrl.searchParams.set('category', selectedCategory);
        } else {
            newUrl.searchParams.delete('category'); // Remove the category if empty
        }
        history.pushState(null, '', newUrl);

        // Load content based on the selected category
        loadContentByCategory(selectedCategory);
    });

	// Wrap elements in classes if current page is .story-page
	if ( jQuery('.story-page').length ) {

		// Wrap .wp-video in .full-video div
		jQuery('.wp-video').wrap('<div class="full-video"></div>');
		
		// Wrap image that start with wp-image-* in .full-image div
		jQuery('img[class*="wp-image-"]').wrap('<div class="full-image"></div>');

		// Wrap .news-gallery in .full-gallery div
		jQuery('.news-gallery').wrap('<div class="full-gallery"></div>');

		// Add class to each <p> preceding <h2>, <h3>, <h4>, or <h5> inside .story-text-styles
		jQuery('.story-text-styles h2, .story-text-styles h3, .story-text-styles h4, .story-text-styles h5')
        .prev('p:not(.paragraph-spacer):not(.preamble)')
        .addClass('paragraph-spacer');

	}

	// Wrap elements in classes if current page is .news-page
	if ( jQuery('.news-page').length ) {

		// Add class to each <p> preceding <h2>, <h3>, <h4>, or <h5> inside .news-text-styles
		jQuery('.news-text-styles h2, .news-text-styles h3, .news-text-styles h4, .news-text-styles h5')
        .prev('p:not(.paragraph-spacer):not(.preamble)')
        .addClass('paragraph-spacer');

	}

	// Hubspot form
	// Function to check input value and toggle class accordingly
	function updateLabelState(input) {
		let $label = jQuery(input).closest('.hs-form-field').find('label');
		if (jQuery(input).val().trim() !== '') {
			$label.addClass('label-focused');
		} else {
			$label.removeClass('label-focused');
		}
	}

	// Event delegation for dynamically loaded inputs
	jQuery(document).on('focus', '.hs-input', function() {
		jQuery(this).closest('.hs-form-field').find('label').addClass('label-focused');
	}).on('blur', '.hs-input', function() {
		updateLabelState(this);
	});

	// Check on page load for pre-filled fields (e.g., autofill)
	jQuery('.hs-input').each(function() {
		updateLabelState(this);
	});

	// Check again after a short delay to catch any autofilled values
	setTimeout(function() {
		jQuery('.hs-input').each(function() {
			updateLabelState(this);
		});
	}, 100);

	// Move legal consent container into submit area for all forms
	function moveLegalConsentContainers() {
		const forms = document.querySelectorAll('.hbspt-form');
		
		forms.forEach(function(form) {
			const legalConsentContainer = form.querySelector('.legal-consent-container');
			const submitContainer = form.querySelector('.hs_submit .actions');
			
			if (legalConsentContainer && submitContainer && !legalConsentContainer.dataset.moved) {
				// Move the legal consent container to be a sibling of the submit button
				submitContainer.parentNode.insertBefore(legalConsentContainer, submitContainer);
				legalConsentContainer.dataset.moved = 'true';
				console.log('Legal consent container moved successfully for form:', form);
			}
		});
	}

	// Listen for HubSpot form events
	window.addEventListener('message', function(event) {
		if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
			setTimeout(moveLegalConsentContainers, 100);
		}
	});

	// Fallback: Check periodically for the form elements
	let checkInterval = setInterval(function() {
		const forms = document.querySelectorAll('.hbspt-form');
		const unmovedContainers = document.querySelectorAll('.legal-consent-container:not([data-moved])');
		
		if (forms.length > 0 && unmovedContainers.length > 0) {
			moveLegalConsentContainers();
		}
		
		// Clear interval if all containers are moved
		if (unmovedContainers.length === 0) {
			clearInterval(checkInterval);
		}
	}, 500);

	// Clear interval after 15 seconds to avoid infinite checking
	setTimeout(function() {
		clearInterval(checkInterval);
	}, 15000);
 
});



